<template>
  <div>

    <!-- Top Info Grid -->
    <section class="top-info py-2">
      <b-container>
        <b-row class="text-center align-items-center">
          <b-col md="4" class="info-item">
            <strong>Our Office</strong><br />
            <small>laaga rd 4 elepe ikorodu, Lagos stste</small>
          </b-col>

          <b-col md="4" class="info-item">
            <strong>Email Us</strong><br />
            <small>olaleresomod24@gmail.com</small>
          </b-col>

          <b-col md="4" class="info-item">
            <strong>Contact Us</strong><br />
            <small>+234 800 123 4567</small>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <!-- NAVBAR -->
    <b-navbar toggleable="lg" type="dark" variant="dark" class="bg-dark">
      <b-navbar-brand to="/">JEWELUX</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse" />
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item to="/">Home</b-nav-item>
          <b-nav-item to="/shop">Shop</b-nav-item>
          <b-nav-item to="/about">About Us</b-nav-item>
          <b-nav-item to="/partners">Partners</b-nav-item>
          <b-nav-item to="/contact">contacts</b-nav-item>
          <b-nav-item to="/cart">cart</b-nav-item>
        </b-navbar-nav>


      </b-collapse>
    </b-navbar>

    <!-- HERO SECTION -->
    <section class="hero text-white text-center">
      <img class="img testimonial-img" src="../assets/person_1.jpg" />
      <div class="overlay">
        <h1>Your Cart</h1>
        <p>Review your selected products</p>
      </div>
    </section>

    <!-- CART ITEMS -->
    <section class="container py-5">
      <h2 class="text-center mb-4">Shopping Cart</h2>

      <!-- Product 1 -->
      <div v-if="cart.length >= 1" class="row align-items-center mb-3">
        <div class="col-md-3">   
        </div>
        <div class="col-md-6">
          <h6>{{ cart[0].name }}</h6>
          <p>Price: ${{ cart[0].price }}</p>
          <p>Quantity: {{ cart[0].qty }}</p>
        </div>
        <div class="col-md-3">
          <b-button variant="danger" @click="removeFromCart(0)">Remove</b-button>
        </div>
      </div>

      <!-- Product 2 -->
      <div v-if="cart.length >= 2" class="row align-items-center mb-3">
        <div class="col-md-3">
         
        </div>
        <div class="col-md-6">
          <h6>{{ cart[1].name }}</h6>
          <p>Price: ${{ cart[1].price }}</p>
          <p>Quantity: {{ cart[1].qty }}</p>
        </div>
        <div class="col-md-3">
          <b-button variant="danger" @click="removeFromCart(1)">Remove</b-button>
        </div>
      </div>

      <!-- Product 3 -->
      <div v-if="cart.length >= 3" class="row align-items-center mb-3">
        <div class="col-md-3">
         
        </div>
        <div class="col-md-6">
          <h6>{{ cart[2].name }}</h6>
          <p>Price: ${{ cart[2].price }}</p>
          <p>Quantity: {{ cart[2].qty }}</p>
        </div>
        <div class="col-md-3">
          <b-button variant="danger" @click="removeFromCart(2)">Remove</b-button>
        </div>
      </div>

      <!-- You can add more manually up to 12 products -->

      <div class="text-center mt-4">
        <h5>Total: ${{ total }}</h5>
        <b-button variant="dark" @click="$router.push('/checkout')">Proceed to Checkout</b-button>
      </div>
    </section>
    <!---Modern Footer -->
    <b-container fluid class="bg-dark text-white pt-5 pb-3">
      <b-row class="text-center text-md-left">

        <!-- Brand / Logo -->
        <b-col md="3" class="mb-4">
          <h4 class="text-gold font-weight-bold">JEWELUX</h4>
          <p class="small">Luxury handcrafted jewelry for every occasion.</p>
        </b-col>

        <!-- Quick Links -->
        <b-col md="3" class="mb-4">
          <h5 class="text-uppercase">Quick Links</h5>
          <ul class="list-unstyled">
            <li><a href="#" class="text-white">Home</a></li>
            <li><a href="#" class="text-white">Shop</a></li>
            <li><a href="#" class="text-white">About</a></li>
            <li><a href="#" class="text-white">Contact</a></li>
          </ul>
        </b-col>

        <!-- Social Media -->
        <b-col md="3" class="mb-4">
          <h5 class="text-uppercase">Follow Us</h5>
          <div>
            <b-icon icon="facebook" font-scale="1.5" class="mr-2 text-white"></b-icon>
            <b-icon icon="instagram" font-scale="1.5" class="mr-2 text-white"></b-icon>
            <b-icon icon="twitter" font-scale="1.5" class="mr-2 text-white"></b-icon>
          </div>
        </b-col>

        <!-- Newsletter -->
        <b-col md="3" class="mb-4">
          <h5 class="text-uppercase">Newsletter</h5>
          <b-form @submit.prevent="subscribe">
            <b-input-group size="sm">
              <b-form-input v-model="email" type="email" placeholder="Your email" required></b-form-input>
              <b-input-group-append>
                <b-button type="submit" variant="gold">Subscribe</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form>
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <b-col class="text-center small">
          &copy; 2026 JEWELUX. All rights reserved.
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'CartPageNoVfor',
  data() {
    return {
      cart: JSON.parse(localStorage.getItem('cart')) || []
    }
  },
  computed: {
    total() {
      return this.cart.reduce((sum, item) => sum + item.price * item.qty, 0)
    }
  },
  methods: {
    removeFromCart(index) {
      this.cart.splice(index, 1)
      localStorage.setItem('cart', JSON.stringify(this.cart))
    }
  }
}
</script>

<style scoped>
.hero {
  position: relative;
  height: 50vh;
}

.hero img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.bg-black {
  background-color: #000;
}

.img {
  width: 100%;
  border-radius: 12px;
}

/* Footer Styling */
.text-gold {
  color: #bfa14b;
}
</style>